import { render } from "./ApproveWallet.vue?vue&type=template&id=aa84cd84&scoped=true"
import script from "./ApproveWallet.vue?vue&type=script&lang=js"
export * from "./ApproveWallet.vue?vue&type=script&lang=js"

import "./ApproveWallet.vue?vue&type=style&index=0&id=aa84cd84&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa84cd84"]])

export default __exports__